<div class='branding--page-header' [innerHTML]='brandingPageHeader'></div>
<div class='router-outlet-container'>
	<router-outlet></router-outlet>
</div>
<div class='branding--page-footer' [innerHTML]='brandingPageFooter'></div>
